export const createMessageMarkup = (message) => `<div class="input-upload__message">
                                                  <p class="input-upload__message-slogan">Попробуйте еще раз</p>
                                                  <p class="input-upload__message-info">${message}</p>
                                                </div>`;
